// Showroom customer session helper — stores the customer's session token in localStorage
// so every public-product API call automatically passes the X-Customer-Session header.
//
// Lifecycle:
//   1. Staff logs in on the showroom tablet (heda_token).
//   2. Staff (via CustomerOnboarding modal) starts a session → POST /api/showroom/session/start.
//   3. Token is stored under heda_customer_session.
//   4. Public product pages call api.js → axios interceptor (see api.js) injects the header.
//   5. Every product view automatically logs an event on the backend.
//   6. Staff ends the session when the customer leaves.

const KEY = "heda_customer_session";

export function getCustomerSession() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setCustomerSession(session) {
  if (!session) {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new Event("heda-customer-session-changed"));
    return;
  }
  localStorage.setItem(KEY, JSON.stringify(session));
  window.dispatchEvent(new Event("heda-customer-session-changed"));
}

export function clearCustomerSession() {
  setCustomerSession(null);
}

export function isLiked(productId) {
  const s = getCustomerSession();
  return !!(s && s.liked_product_ids && s.liked_product_ids.includes(productId));
}

export function toggleLikedLocally(productId, liked) {
  const s = getCustomerSession();
  if (!s) return;
  const ids = new Set(s.liked_product_ids || []);
  if (liked) ids.add(productId);
  else ids.delete(productId);
  s.liked_product_ids = Array.from(ids);
  setCustomerSession(s);
}
